import classnames from 'classnames';
import * as React from 'react';
import { base, kind, disabled } from './dot.css.js';

/**
 * A dot is a small circular indicator used to represent a specific dynamic status or to highlight important information, such as notifications or updates in a particular area.
 */
const Dot = ({ className, kind: kind$1 = 'highlight', disabled: disabled$1 = false, ...rest }) => {
    return (React.createElement("div", { ...rest, role: "status", className: classnames(base, kind[kind$1], {
            [disabled]: disabled$1,
        }, className) }));
};

export { Dot };
